import { RouteConfig } from "vue-router";
import UnauthorizeComponent from "@/views/unauthorize/unauthorize.vue";

export const UNAUTHORIZE_ROUTES: RouteConfig[] = [
  {
    path: "/unauthorize",
    name: "UnauthorizeComponent",
    component: UnauthorizeComponent
  }
];